import React from "react";
import { Status } from "@fluentui/react-northstar";
import { AcceptIcon } from "@fluentui/react-icons-northstar";
import PropTypes from "prop-types";

const AvailableStatus = (props) => {
  const { size } = props;

  return (
    <Status
      data-testid="availableStatus"
      state="success"
      icon={<AcceptIcon />}
      size={size}
    />
  );
};

AvailableStatus.propTypes = {
  size: PropTypes.string,
};

AvailableStatus.defaultProps = {
  size: "larger",
};

export default AvailableStatus;
